import React from 'react'
import { PhotoProvider, PhotoView } from 'react-photo-view'
import "react-photo-view/dist/react-photo-view.css";

const PhotoClipView = ({ 
  images, 
  thumbnailSize = 'w-10 h-10', 
  maxVisibleThumbnails = 3,
  thumbnailBorderClass = 'border-2 border-background',
  thumbnailOverlap = '-ml-3',
  moreIndicatorBgClass = 'bg-secondary/20',
  moreIndicatorTextClass = 'text-secondary/90',
  containerClass = 'flex mt-1'
}) => {
  return (
    <PhotoProvider>
      {Array.isArray(images) && images.length > 0 && (
        <>
          <div className={containerClass}>
            {/* Visible thumbnails - first N images based on maxVisibleThumbnails */}
            {images.slice(0, maxVisibleThumbnails).map((url, index) => (
              <PhotoView key={`visible-${index}`} src={url}>
                <div 
                  className={`${thumbnailSize} rounded-2xl ${thumbnailBorderClass} bg-secondary/10 overflow-hidden cursor-pointer hover:opacity-90 transition-opacity ${index > 0 ? thumbnailOverlap : ''}`}
                  style={{ zIndex: maxVisibleThumbnails + 1 - index }}
                >
                  <img 
                    src={url} 
                    alt={`Attachment ${index + 1}`} 
                    className="w-full h-full object-cover text-xs truncate"
                  />
                </div>
              </PhotoView>
            ))}
            
            {/* "+X" indicator for remaining images */}
            {images.length > maxVisibleThumbnails && (
              <PhotoView key="visible-more" src={images[maxVisibleThumbnails]}>
                <div 
                  className={`${thumbnailSize} rounded-2xl ${thumbnailBorderClass} overflow-hidden cursor-pointer hover:opacity-90 transition-opacity ${thumbnailOverlap} flex items-center justify-center ${moreIndicatorBgClass}`}
                  style={{ zIndex: 0 }}
                >
                  <span className={`font-bold font-nunito text-caption ${moreIndicatorTextClass}`}>+{images.length - maxVisibleThumbnails}</span>
                </div>
              </PhotoView>
            )}
          </div>
          
          {/* Hidden PhotoView components for all remaining images */}
          {images.slice(maxVisibleThumbnails + 1).map((url, index) => (
            <PhotoView key={`hidden-${index}`} src={url} className="hidden" />
          ))}
        </>
      )}
    </PhotoProvider>
  )
}

export default PhotoClipView